import { useState } from 'react'
import { copyTableToClipboard } from './copyTableToClipboard'
import { PrintPreviewModal } from './PrintPreviewModal'

export type CopyTablePayload = {
  headers: string[]
  rows: string[][]
  preamble?: string[]
}

type Props = {
  /** Full dataset for the panel (ignores pagination/slice). */
  payload: CopyTablePayload
  inverted?: boolean
  className?: string
  disabled?: boolean
}

/** Copy + Print controls for Early Signals tables and lists. */
export function CopyTableButtons({ payload, inverted = false, className = '', disabled }: Props) {
  const [copied, setCopied] = useState(false)
  const [previewOpen, setPreviewOpen] = useState(false)
  const empty = payload.rows.length === 0

  const btnClass = inverted
    ? 'text-white/90 border-white/30 hover:bg-white/10 disabled:opacity-50'
    : 'text-es-muted border-es-soft hover:border-es-signal hover:text-es-signal bg-es-white disabled:opacity-50'

  const runCopy = async () => {
    try {
      await copyTableToClipboard(payload)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2000)
    } catch {
      setCopied(false)
    }
  }

  return (
    <>
      <div className={`inline-flex flex-wrap items-center gap-1.5 ${className}`}>
        <button
          type="button"
          disabled={disabled || empty}
          title="Copy rows"
          onClick={() => void runCopy()}
          className={`inline-flex items-center gap-1.5 px-2 py-1 text-[11px] font-semibold uppercase tracking-wider rounded border transition-colors ${btnClass}`}
        >
          <i className={`fa-solid ${copied ? 'fa-check' : 'fa-copy'}`} aria-hidden />
          {copied ? 'Copied' : 'Copy'}
        </button>
        <button
          type="button"
          disabled={disabled || empty}
          title="Print preview"
          onClick={() => setPreviewOpen(true)}
          className={`inline-flex items-center gap-1.5 px-2 py-1 text-[11px] font-semibold uppercase tracking-wider rounded border transition-colors ${btnClass}`}
        >
          <i className="fa-solid fa-print" aria-hidden />
          Print
        </button>
      </div>
      <PrintPreviewModal
        open={previewOpen}
        payload={payload}
        onClose={() => setPreviewOpen(false)}
      />
    </>
  )
}
